import { getWithToken } from 'api/network';

/**
 * Multi-ID search for the Dashboard "Search" page.
 * @param {string} idType One of: opportunityId, taskId, assetId, asgPropID.
 * @param {string|number} id The identifier value to search for.
 * @returns {Promise<Array>} Combined acq + post-acq result rows (IdSearchResultDto).
 */
export async function IdSearch(idType, id) {
  const url = `/api/dashboard/idSearch?idType=${encodeURIComponent(idType)}&id=${encodeURIComponent(id)}`;
  const response = await getWithToken(url);
  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `Search failed (${response.status})`);
  }
  return await response.json();
}
